import {
  ERROR_UNALLOCATED_POSTCODES_TITLE,
  WARNING_UNALLOCATED_POSTCODES_TITLE,
} from "../../../consts/strings";

import { Modal } from "../Modal";
import { UnallocatedPostcodeAction } from "./UnallocatedPostcodesAction";
import { UnallocatedPostcodesContent } from "./UnallocatedPostcodesContent";
import { memo } from "react";

export const UnallocatedPostcodesModal = memo(
  ({ open, onClose, onContinue, postcodes, error = true }) => {
    return (
      <Modal
        open={open}
        onClose={onClose}
        title={
          error
            ? ERROR_UNALLOCATED_POSTCODES_TITLE
            : WARNING_UNALLOCATED_POSTCODES_TITLE
        }
        content={
          <UnallocatedPostcodesContent postcodes={postcodes} error={error} />
        }
        actions={
          <UnallocatedPostcodeAction
            error={error}
            onCancel={onClose}
            onContinue={onContinue}
          />
        }
        maxWidth={"sm"}
      />
    );
  }
);
